import React, { useContext } from 'react';
/* eslint-disable-next-line max-len */
import DataGatheringBanner from '../../../components/react/data_gathering_banner/bootstrap_5/data_gathering_banner_bootstrap_5';
import { JobSearchContext } from '../../context';

const Header = () => {
  const { userInfo, dataGatheringBannerField, } = useContext(JobSearchContext);

  const renderMakeProfilePublic = (
    <div className='alert alert-warning py-3' role='alert'>
      Recruiters can&lsquo;t see your profile because it&lsquo;s set to private.
      <a href='/account' className='alert-link'> Click here to make your profile public</a>
    </div>
  );

  return (
    <>
      {userInfo.hasPrivateProfile && renderMakeProfilePublic}
      {dataGatheringBannerField && (
        <DataGatheringBanner requestedField={dataGatheringBannerField} />
      )}
    </>
  );
};

export default Header;
